import { useState } from "react";
import { IconButton, Modal } from "src/Components";
import { Input } from "src/Components/Controls";
import { SelectBox } from "src/UI";
import { IModalProps } from "..";
import "./ReturnWorkdayEndModal.scss";

const OTHER_REASON = "other";

const workdayEndReasons: Array<{ id: string; title: string }> = [
	{ id: "workday-ended", title: "Рабочий день завершён" },
	{ id: "schedule-ended", title: "Завершение работы по графику" },
	{ id: OTHER_REASON, title: "Другая причина" }
];

const ReturnWorkdayEndModal: React.FC<IModalProps> = ({ isOpen, onClose, onAction }) => {
	const [ reason, setReason ] = useState<string>("");
	const [ otherReason, setOtherReason ] = useState<string>("");
	const isOtherReason = reason === OTHER_REASON;
	const selectedReason = workdayEndReasons.find(item => item.id === reason)?.title || "";
	const resolvedReason = isOtherReason ? otherReason.trim() : selectedReason;

	const handleReasonChange = (value: string) => {
		setReason(value);
		if (value !== OTHER_REASON) setOtherReason("");
	};

	const renderBody: React.FC = () => (
		<div className="return-workday-end-modal__body">
			<label className="return-workday-end-modal__label">
				Причина завершения <span>*</span>
			</label>
			<SelectBox
				options={workdayEndReasons}
				selectedValues={reason ? [reason] : []}
				onChangeSelected={(items) => handleReasonChange(items[0]?.id ?? "")}
				placeholder="Выберите причину из списка"
				allowClear
			/>
			{isOtherReason && (
				<>
					<label className="return-workday-end-modal__label">
						Другая причина завершения <span>*</span>
					</label>
					<Input
						value={otherReason}
						onChangeValue={setOtherReason}
						className="return-workday-end-modal__input"
					/>
				</>
			)}
		</div>
	);

	const renderFooter = (
		<>
			<IconButton color="red" outline onClick={onClose}>Отмена</IconButton>
			<IconButton color="green" disable={!resolvedReason} onClick={() => onAction("return-finish-work", resolvedReason)}>
				Завершить работу
			</IconButton>
		</>
	);

	return (
		<Modal
			isOpen={isOpen}
			title="Завершение работы окна"
			titleType="small"
			onClose={onClose}
			color="light"
			className="return-workday-end-modal"
			renderBody={renderBody}
			renderFooter={renderFooter}
		/>
	);
};

export default ReturnWorkdayEndModal;
